export default "__VITE_ASSET__Ds9007Vv__"